import Vue from 'vue'
import Router from 'vue-router'
import index from '../components/pages/index.vue'
import joinUs from '../components/pages/joinUs.vue'
import help from '../components/pages/help.vue'
import privacy from '../components/pages/privacy.vue'
import design from '../components/joinChild/design.vue'
import content from '../components/joinChild/content.vue'
import operation from '../components/joinChild/operation.vue'
import technology from '../components/joinChild/technology.vue'
Vue.use(Router)

export default new Router({
    routes: [
        {path: '/', redirect: '/index'},
        {
            path: '/index',
            name: 'index',
            component: index
        },
        {
            path: '/joinUs',
            name: 'joinUs',
            component: joinUs,
        },
        {
            path: '/help',
            name: 'help',
            component: help
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: privacy
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js